import Forbidden from '../../../base/pages/errorPages/Forbidden';

const forbidden: Forbidden = {
  title: 'Unbefugter Zugriff',
  subtitle: 'Sie haben keine Berechtigung, diese Seite anzuzeigen.',
  quip: 'Wenn ich du wäre, würde ich gehen, Radek wartet vor der Tür!'
};

export default forbidden;
